export default __webpack_public_path__ + "static/media/icons8-reddit-240.a92347e2.png";